export default "__VITE_ASSET__assxPdSU__"